import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1011. 支払タスクフェーズ更新（前へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:id/move_to_prev_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  current_payment_task_phase_id: number;
};

const movePaymentTaskPhaseToPrev = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/move_to_prev_phase`,
    props
  );
};

export const useMovePaymentTaskPhaseToPrev = () => {
  return useMutation({
    mutationFn: movePaymentTaskPhaseToPrev,
  });
};
